export default {
    successful_action_title: 'OK!',
    successful_action_text: 'Ação executada com sucesso!',
    confirm_deactivate: {
        title: 'Você tem certeza que deseja desativar?',
        title_particular: 'Você deseja desativar o item {{item}}?',
        title_close_chat: 'Encerrar Chat',
        text: 'O item será desativado e não será possível utilizá-lo até ativá-lo novamente.',
        text_close_chat: 'Ao encerrar o chat não será mais possível interagir nesse chat, tem certeza que deseja encerrar?',
        text_success: 'O item {{item}} foi desativado!',
        text_success_close_chat: 'Chat encerrado com sucesso!',
        button_confirm: 'Sim, desativar',
        button_close_chat: 'Sim, encerrar o chat',
    },
    confirm_delete: {
        title: 'Você tem certeza que deseja deletar?',
        title_particular: 'Você deseja deletar o item {{item}}?',
        title_workload: 'Você tem certeza que deseja deletar essa carga?',
        text: 'Após deletar o item, você não poderá reverter essa ação, tem certeza que deseja continuar?',
        text_organization: 'Ao deletar essa Organização também será deletado os Clientes e Grupos de Atendimentos vinculados a ela. ' +
            'Você não poderá reverter essa ação, tem certeza que deseja continuar?',
        text_attendance_group: 'Ao deletar esse Grupo de Atendimento não será mais possível visualizar os Chamados pertencentes a ele.' +
            'Você não poderá reverter essa ação, tem certeza que deseja continuar?',
        text_sla_config: "Você está excluindo a configuração do SLA do grupo de atendimento <b>'{{attendance_group_name}}'</b> e da categoria <b>'{{call_category_name}}'</b>.",
        button_confirm: 'Sim, deletar',
        text_success: 'O item {{item}} foi excluído!',
        text_success_sla_config: "O SLA para o grupo de atendimento <b>'{{attendance_group_name}}'</b> e categoria <b>'{{call_category_name}}'</b> foi excluído. " +
            "<br>Agora os chamados vinculados a esse grupo de atendimento e categoria não possuem mais controle de SLA.",
        title_call_spam: 'Excluir e Marcar Chamado como Spam',
        text_call_spam: 'Após executar essa ação o chamado será <b>excluído permanentemente</b> do sistema e o e-mail que ' +
            'abriu esse chamado será marcado como SPAM para não abrir mais chamados ao receber e-mails com esse remetente, ' +
            'tem certeza que deseja continuar?',
    },
    confirm_restore: {
        title: 'Você tem certeza que deseja restaurar?',
        title_particular: 'Você deseja restaurar o item {{item}}?',
        text: 'O item será restaurado e será possível utiliza-lo normalmente',
        button_confirm: 'Sim, restaurar',
        text_success: 'O item {{item}} foi restaurado!',
    },
    confirm_warning_action: {
        title: 'Você deseja prosseguir com a ação?',
        title_sla_regard: 'Você deseja que o SLA seja considerado?',
        text_sla_regard: 'Após essa ação o SLA será considerado novamente para esse chamado.',
        text_taskier_document: 'Será enviado um e-mail de notificação de atualização do documento {{document_type}} para todos os usuários da plataforma',
        title_archive_task: 'Você deseja arquivar essa tarefa?',
        text_archive_task: 'Após arquivar a tarefa não será mais possível atualizá-la.',
        text_success_archive_task: 'Esta tarefa foi arquivada em {{date}}. Você não pode atualizar as informações dessa tarefa.',
        title_archive_ticket: 'Você deseja arquivar esse chamado?',
        text_archive_ticket: 'Após arquivar o chamado não será mais possível atualizá-lo.',
        button_confirm: 'Sim, prosseguir',
        title_unsubscribe: 'Você deseja cancelar a sua assinatura atual?',
        text_unsubscribe: 'Ao cancelar a assinatura você retornará para o plano Free e não será feito mais cobranças ' +
            'no seu cartão. Você ainda poderá aproveitar os benefícios do plano atual pelo período já pago. ' +
            'Veja a diferença dos recursos dos planos',
        title_success_unsubscribe: 'Assinatura Cancelada!',
        text_success_unsubscribe: 'Sua assinatura foi cancelada com sucesso.',
    },
    edit_success: {
        text: 'Dados atualizados com sucesso!',
        text_admin: 'Administrador atualizado com sucesso!',
        text_agent: 'Usuário atualizado com sucesso!',
        text_agreed_load: 'Carga atualizada com sucesso!',
        text_attendance_group: 'Grupo de Atendimento atualizado com sucesso!',
        text_attendance_type: 'Status atualizado com sucesso! {{info}}',
        text_call: 'Chamado número {{number}} foi atualizado com sucesso!',
        text_call_config_email: 'Configuração de E-mail atualizado com sucesso!',
        text_category: 'Categoria atualizada com sucesso!',
        text_customer: 'Cliente atualizado com sucesso!',
        text_faq_article: 'Artigo do FAQ atualizado com sucesso!',
        text_faq_category: 'Categoria do FAQ atualizada com sucesso!',
        text_holiday: 'Feriado atualizado com sucesso!',
        text_organization: 'Organização atualizada com sucesso!',
        text_role: 'Perfil de Acesso atualizado com sucesso!',
        text_sla_config: 'Configuração de SLA atualizada com sucesso!',
        text_workload: 'Carga de Trabalho atualizada com sucesso!',
        text_work_type: 'Tipo de Carga de Trabalho atualizada com sucesso!',
        text_responsible_attach: 'Responsável vinculado com sucesso!',
        text_plan: 'Plano atualizado com sucesso!',
        text_task_status: 'Status da Tarefa atualizado com sucesso!',
        text_task_type: 'Tipo de Tarefa atualizado com sucesso!',
        text_task: 'Tarefa número {{number}} editada com sucesso!',
        title_subscription: 'Assinatura Atualizada!',
        text_subscription: 'Parabéns, sua assinatura foi atualizada com sucesso.',
    },
    save_success: {
        text: 'Cadastro realizado com sucesso!',
        text_admin: 'Administrador cadastrado com sucesso!',
        text_agent: 'Usuário cadastrado com sucesso!',
        text_agreed_load: 'Carga adicionada com sucesso!',
        text_attendance_group: 'Grupo de Atendimento cadastrado com sucesso!',
        text_attendance_type: 'Status cadastrado com sucesso!',
        text_call: 'Chamado número {{number}} foi cadastrado com sucesso!',
        text_call_access: 'Acessar chamado #{{number}}',
        text_call_config_email: 'Configuração de E-mail cadastrado com sucesso!',
        text_category: 'Categoria cadastrada com sucesso!',
        text_customer: 'Cliente cadastrado com sucesso!',
        text_faq_article: 'Artigo do FAQ cadastrado com sucesso!',
        text_faq_category: 'Categoria do FAQ cadastrada com sucesso!',
        text_holiday: 'Feriado cadastrado com sucesso!',
        text_organization: 'Organização cadastrada com sucesso!',
        text_role: 'Perfil de Acesso cadastrado com sucesso!',
        text_sla_config: 'Configuração de SLA cadastrada com sucesso!',
        text_workload: 'Carga de Trabalho cadastrada com sucesso!',
        text_workload_started: 'Atividade iniciada com sucesso!',
        text_work_type: 'Tipo de Carga de Trabalho cadastrada com sucesso!',
        text_call_transfer: 'Chamados transferidos com sucesso!',
        text_plan: 'Plano cadastrado com sucesso!',
        text_task_status: 'Status da Tarefa cadastrado com sucesso!',
        text_task_type: 'Tipo de Tarefa cadastrado com sucesso!',
        text_task: 'Tarefa número {{number}} cadastrada com sucesso!',
        text_task_access: 'Acessar tarefa #{{number}}',
        title_subscription: 'Assinatura Concluída!',
        text_subscription: 'Parabéns, você alterou o plano da sua assinatura para o plano {{plan}}.',
        title_subscription_trial: 'Teste Gratuito Iniciado!',
        text_subscription_trial: 'Parabéns, você iniciou o seu período de teste grátis. Você poderá usar os benefícios do plano {{plan}} até {{- trialEndAt}}',
    },
    call_response: {
        text_success: 'Resposta enviada com sucesso!',
    },
    attendance_type: {
        updated_order: 'A ordem inserida para esse Status é a última ordem da lista. Esse Status foi cadastrado com a ordem {{newOrder}}.'
    },
    archived_ticket: {
        text_success: 'Chamado arquivado com sucesso!',
    },
    timezone_wrong: {
        title: 'As configurações de fuso horário da sua conta estão corretas?',
        text: 'Foi identificado que você provavelmente está no fuso horário <b>{{clientTz}}</b>, ' +
            'porém, sua conta está configurada para <b>{{userTz}}</b>.<br><br> Você deseja ser redirecionado para editar a sua conta?',
        button_confirm: 'Sim, redirecionar',
        button_cancel: 'Não, ignorar aviso',
    },
    service_chat: {
        text_success_agent_transfer: 'Foi enviada uma solicitação de transferência para o usuário. Você será notificado assim que o usuário aceitar e o chat for transferido',
        text_success_cancel_transfer: 'Transferência cancelada com sucesso.',
        button_open_ticket: 'Desejo abrir um chamado',
    },
    remove_sla_config_from_calls: {
        title: 'Remover SLA dos chamados abertos',
        text: 'Você quer remover a configuração do SLA dos chamados ainda em aberto que possuem o grupo de atendimento e categoria da configuração que está sendo deletada?',
        button_confirm: 'Sim, remover a configuração dos chamados',
        button_deny: 'Não, deletar apenas essa configuração',
    },
    update_sla_config_from_calls: {
        title: 'Atualizar SLA dos chamados abertos',
        text: 'Você quer atualizar a configuração do SLA dos chamados abertos que possuem esse grupo de atendimento e categoria?',
        button_confirm: 'Sim, atualizar a configuração dos chamados',
        button_deny: 'Não, apenas atualizar essa configuração',
    },
    update_sla_config_from_call: {
        text: 'Após atualizar, a configuração do SLA para esse chamado será igual ao do cadastro atual do grupo de atendimento e categoria desse chamado.',
        text_success: 'A configuração do SLA desse chamado foi atualizado de acordo com o cadastro atual do grupo de atendimento e categoria do chamado.',
    },
    update_business_time_from_calls: {
        title: 'Atualizar Horário de Atendimento dos Chamados Abertos',
        text: 'Você quer atualizar o horário de atendimentos dos chamados em aberto que possuem esse grupo de atendimento?<br><br>' +
            '<b>Aviso:<b> Caso você atualize o horário de atendimentos dos chamados em aberto, será recalculado o SLA para aqueles que tiverem SLA ',
        text_success: 'Grupo de Atendimento atualizado com sucesso! <br>Pode levar alguns minutos até que todos os chamados em aberto sejam atualizados com o novo horário de atendimento.',
        button_confirm: 'Sim, atualizar os chamados',
        button_deny: 'Não, apenas atualizar esse grupo',
    },
    call_not_found: {
        title: 'Chamado não localizado',
        text: 'O chamado número {{number}} não foi localizado, confirme se você digitou o número correto e se você pertence ao grupo de atendimento do chamado',
    },
    tinymce_paste_image_title: 'Ação não permitida',
    tinymce_paste_image_text: 'Não é possível adicionar uma imagem no corpo da mensagem',
    tinymce_image_upload: {
        title: 'Problema no upload das Imagens!',
        text: 'Não foi possível fazer o upload de uma das imagens dentro da sua mensagem. Tente excluir e adicionar a imagem novamente.',
    },
    workload_already_finished: {
        title: 'Atividade já finalizada',
        text: 'Essa atividade já foi finalizada, atualize a página por gentileza'
    },
    days_left_to_delete_tenant: '{{time}} será excluído permanente',
    corporate_plan: {
        title: 'Plano Corporate',
        text: 'Entre em contato conosco através do nosso e-mail {{- link}}',
    },
}
